import { GenericTestRouteState } from './generic-test-state'

export const ClinicalTestRouteState = GenericTestRouteState.named(
  'ClinicalTestRouteState'
)
